var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center h5 mt-4"},[(!_vm.messsage)?_c('b-spinner',{attrs:{"variant":"success","type":"grow"}}):_vm._e(),(_vm.message)?_c('p',[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }